module.exports = __webpack_public_path__ + "assets/img/kv-977b6e31.jpg";